import { render } from "./WorkflowFolgenButton.pug?vue&type=template&id=d884b37c&lang=pug"
import script from "./WorkflowFolgenButton.js?vue&type=script&lang=js"
export * from "./WorkflowFolgenButton.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__